(() => {
  angular
    .module('gm.common.directives')
    .directive('includeTemplate', includeTemplateDirective);

  function includeTemplateDirective(
    $http,
    $templateCache,
    $compile
  ) {
    'ngInject';

    return function _includeTemplate($scope, element, attrs) {
      const template = attrs.includeTemplate;

      $http.get(template, {
        cache: $templateCache,
      })
      .then(({ data }) => {
        const contents = element.html(data).contents();
        let scope;

        if (attrs.scope === 'parent') {
          scope = $scope.$parent;
        }

        $compile(contents)(scope || $scope);
      });
    };
  }
})();
